import 'babel-polyfill';
import qs from 'qs';
import Vue from 'vue';
import App from './app.vue';
import fetch from '../../lib/fetch'
import store from './store';
import * as service from './service'
import { confirm, alert, prompt } from '../../common/components/modal'
import $message from '../../common/components/message'
import '../../common/style/index.scss';
import 'normalize.css';

Vue.prototype.$query = window.$query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
Vue.prototype.$service = service;
Vue.prototype.$message = $message;
Vue.prototype.$confirm = confirm;
Vue.prototype.$alert = alert;
Vue.prototype.$prompt = prompt;
Vue.prototype.$fetch = fetch;
Vue.prototype.$loading = function (is = true) {
	this && this.$root && this.$root.$emit('loading', is)
};

new Vue({
	store,
	render: h => h(App),
}).$mount('#app')
